import { ChangeEvent, FormEvent } from "react";

type InputElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

export type ChangeEventHandler = (e: ChangeEvent<InputElement>) => void;
export type InputEventHandler = (e: FormEvent<InputElement>) => void;

// Keep in sync with src/wam/models/value.go
export enum ValueType {
	Null = 0,
	Float,
	Integer,
	Boolean,
};

// Keep in sync with src/wam/models/goals.go
export enum GoalSourceType {
	MeasurementSource = 0,
	ChecklistSource,
};

// Keep in sync with src/wam/models/goals.go
export enum GoalAggregationType {
	Identity = 0,
	Sum,
	Max,
	Min,
};

// Keep in sync with src/wam/models/goals.go
export enum GoalTargetType {
	Linear = 0,
};

// Keep in sync with src/wam/models/measurements.go
export enum MeasurementInputType {
	Null = 0,
	EntryInput,
	ChecklistInput,
};

export type ValueResponse = number | boolean | null;